// 各頁面原本硬編中文抽出的詞條（CB7REQ-170）；key 為語言中性，四語系同步維護
export default {
  "pageText.activity.memberAccountOrPhone": "Tài khoản / Số điện thoại",
  "pageText.activity.freeCheckinPoints": "Điểm phát cho điểm danh miễn phí",
  "pageText.activity.depositCheckinPoints": "Điểm phát cho điểm danh nạp tiền",
  "pageText.activity.unit": "Đơn vị",
  "pageText.activity.issueQty": "Số lượng phát",
  "pageText.activity.treasureIssuePHP": "Phát hộp báu (PHP)",
  "pageText.activity.treasureIssueUSDT": "Phát hộp báu (USDT)",
  "pageText.activity.treasureIssueVND": "Phát hộp báu (VND)",
  "pageText.activity.treasureClaimPHP": "Nhận hộp báu (PHP)",
  "pageText.activity.treasureClaimUSDT": "Nhận hộp báu (USDT)",
  "pageText.activity.treasureClaimVND": "Nhận hộp báu (VND)",
  "pageText.activity.treasureExpirePHP": "Hộp báu hết hạn (PHP)",
  "pageText.activity.treasureExpireUSDT": "Hộp báu hết hạn (USDT)",
  "pageText.activity.treasureExpireVND": "Hộp báu hết hạn (VND)",
  "pageText.activity.qtyMustBePositive": "Số lượng phải lớn hơn 0",
  "pageText.activity.maxValue": "Giá trị tối đa",
  "pageText.activity.minValue": "Giá trị tối thiểu",
  "pageText.activity.maxAmountGteMin": "Số tiền tối đa phải >= tối thiểu",
  "pageText.activity.idRequired": "Chưa nhập ID",
  "pageText.activity.actPkRequired": "Cần mã khóa chính của hoạt động; hãy tải cấu hình trước",
  "pageText.activity.filter": "Lọc",
  "pageText.activity.queryUserStatusFirst": "Vui lòng truy vấn trạng thái người dùng trước",
  "pageText.activity.bonusRangesRequired100": "Cấu hình đủ các mức thưởng với tổng tỷ lệ 100%",
  "pageText.activity.uploadAtLeastOneImage": "Vui lòng tải lên ít nhất một hình ảnh",
  "pageText.activity.addAtLeastOneBonusRange": "Vui lòng thêm ít nhất một mức thưởng",
  "pageText.activity.enterIssueQty": "Vui lòng nhập số lượng phát",
  "pageText.activity.selectItemType": "Chọn loại mục",
  "pageText.activity.accountsSemicolonHint": "(phân tách nhiều tài khoản bằng ;)",
  "pageText.activity.fileMax50MB": "Tệp không được vượt quá 50MB!",
  "pageText.financial.failCountLimit5Min": "Giới hạn lỗi trong 5 phút",
  "pageText.financial.eg10": "ví dụ 10",
  "pageText.financial.eg10000": "ví dụ 10000.00",
  "pageText.financial.eg500": "ví dụ 500.00",
  "pageText.financial.singlePayLimit": "Giới hạn mỗi lần chi",
  "pageText.financial.paramSetFailed": "Lưu tham số thất bại",
  "pageText.financial.paramSetSuccess": "Đã lưu tham số",
  "pageText.financial.paramConfigFailed": "Cấu hình tham số thất bại",
  "pageText.financial.paramConfigSuccess": "Đã cấu hình tham số",
  "pageText.financial.teamsGroupHint": "Nhập tên nhóm Teams hoặc URL webhook",
  "pageText.financial.rejectFailed": "Từ chối thất bại",
  "pageText.financial.payTypeCode": "Mã loại thanh toán",
  "pageText.financial.payTypeName": "Tên loại thanh toán",
  "pageText.financial.channelNotFound": "Không tìm thấy kênh",
  "pageText.financial.payingInProgress": "Đang chi tiền",
  "pageText.financial.dailyPayLimit": "Giới hạn chi mỗi ngày",
  "pageText.financial.confirmDeletePayType": "Xóa loại thanh toán này?",
  "pageText.financial.confirmRechargeFailed": "Xác nhận nạp tiền thất bại",
  "pageText.financial.confirmRechargeSuccess": "Đã xác nhận nạp tiền",
  "pageText.financial.autoPayoutSwitch": "Công tắc chi tự động",
  "pageText.financial.autoPayoutSort": "Thứ tự chi tự động",
  "pageText.financial.getPayChannelListFailed": "Tải danh sách kênh chi thất bại",
  "pageText.financial.getPayChannelDataFailed": "Tải dữ liệu kênh chi thất bại",
  "pageText.financial.getParamSetFailed": "Tải tham số thất bại",
  "pageText.financial.getPayTypeDataFailed": "Tải loại thanh toán thất bại",
  "pageText.financial.getCurrencyListFailed": "Tải danh sách tiền tệ thất bại",
  "pageText.financial.unlockFailed": "Mở khóa thất bại",
  "pageText.financial.unlockSuccess": "Đã mở khóa",
  "pageText.financial.enterPayTypeCode": "Nhập mã loại thanh toán",
  "pageText.financial.enterPayTypeName": "Nhập tên loại thanh toán",
  "pageText.financial.enterAmountMax2Decimals": "Nhập số tiền tối đa 2 số thập phân",
  "pageText.financial.notifyGroup": "Nhóm thông báo",
  "pageText.financial.lockFailed": "Khóa thất bại",
  "pageText.financial.lockSuccess": "Đã khóa",
  "pageText.luckySpin.effectImmediately": "✓ Hiệu lực ngay",
  "pageText.luckySpin.validSameDayOnly": "Chỉ có hiệu lực trong ngày",
  "pageText.luckySpin.validSameDayOnlyDetail": "Chỉ có hiệu lực trong ngày; hết hạn 00:00 hôm sau",
  "pageText.luckySpin.withinValid": "có hiệu lực trong",
  "pageText.luckySpin.multiLangConfigExternal": "Cấu hình đa ngữ (hiển thị bên ngoài)",
  "pageText.luckySpin.daysHoursNotBothZero": "Số ngày và giờ không thể đều bằng 0",
  "pageText.luckySpin.hourRange": "Phạm vi giờ: 0-23",
  "pageText.luckySpin.hourUnit": "giờ",
  "pageText.luckySpin.effectNextDayMidnight": "Hiệu lực 00:00 hôm sau",
  "pageText.luckySpin.selectAfterClaimMode": "Chọn chế độ sau khi nhận",
  "pageText.luckySpin.afterClaim": "Sau khi nhận",
  "pageText.luckySpin.afterClaimMode": "Chế độ sau khi nhận",
  "pageText.member.anchor": "Streamer",
  "pageText.member.tradeRangeMax7Days": "Khoảng thời gian không được vượt quá 7 ngày",
  "pageText.member.lastOnlineTime": "Lần online cuối: ",
  "pageText.member.lastDepositTime": "Lần nạp cuối: ",
  "pageText.member.registerTime": "Thời gian đăng ký: ",
  "pageText.member.loginDomain": "Tên miền đăng nhập: ",
  "pageText.member.getWalletAccountsFailed": "Tải danh sách ví thất bại",
  "pageText.member.getBankCardsFailed": "Tải danh sách thẻ ngân hàng thất bại",
  "pageText.member.requestFailed": "Yêu cầu thất bại",
  "pageText.member.resetWithdrawPwdError": "Lỗi đặt lại mật khẩu rút tiền",
  "pageText.member.resetLoginPwdError": "Lỗi đặt lại mật khẩu đăng nhập",
  "pageText.member.firstDepositTime": "Lần nạp đầu: ",
  "pageText.sys.createRole": "Tạo vai trò",
  "pageText.sys.failed": "Thất bại",
  "pageText.sys.opFailedRetry": "Thao tác thất bại, vui lòng thử lại",
  "pageText.sys.dataLoadFailed": "Tải dữ liệu thất bại",
  "pageText.sys.memberAccount": "Tài khoản thành viên",
  "pageText.sys.messageContent": "Nội dung tin nhắn",
  "pageText.sys.updateFailed": "Cập nhật thất bại",
  "pageText.sys.addFailed": "Thêm thất bại",
  "pageText.seo.featureInDevelopment": "Tính năng đang phát triển...",
  "pageText.seo.monthlyImpressions": "Lượt hiển thị hàng tháng",
  "pageText.seo.monthlyImpressionsGsc": "Lượt hiển thị hàng tháng (GSC)",
  "pageText.sms.enterSenderId": "Nhập Sender ID",
  "pageText.sms.countryUS": "US - Hoa Kỳ",
  "pageText.risk.supKycPkMissing": "Thiếu supDataPkCode (khóa KYC bổ sung); không thể gửi duyệt",
  "pageText.risk.supKycNotFound": "Không tồn tại thông tin KYC bổ sung",
  "pageText.risk.supKycMemberMissing": "Thiếu ID thành viên trong thông tin KYC bổ sung",
  "pageText.risk.formValidateFailed": "Xác thực biểu mẫu thất bại; kiểm tra các trường bắt buộc",
  "pageText.inbox.startDateTime": "Ngày & giờ bắt đầu",
  "pageText.inbox.endDateTime": "Ngày & giờ kết thúc",
  "pageText.common.loading": "Đang tải...",
  "pageText.common.noData": "Không có dữ liệu",
  "pageText.common.unknown": "Không rõ",
  "pageText.common.filter": "Lọc",
  "pageText.common.allAgents": "Tất cả đại lý",
  "pageText.activity.eggReady": "Chờ ấp",
  "pageText.activity.hatchedNoEnergy": "Đã ấp (không còn năng lượng)",
  "pageText.activity.eg24000": "ví dụ 24000",
  "pageText.activity.onlyTopTier": "Chỉ mức cao nhất được nhập",
  "pageText.financial.editPayType": "Sửa loại thanh toán",
  "pageText.financial.addPayType": "Thêm loại thanh toán",
  "pageText.financial.getDataFailed": "Tải dữ liệu thất bại",
  "pageText.financial.changePayChannelFailed": "Đổi kênh chi thất bại",
  "pageText.risk.rejectFailed": "Từ chối thất bại",
  "pageText.member.streamerUser": "Người dùng streamer",
  "pageText.member.patrolUser": "Người dùng tuần tra",
  "pageText.member.normalUser": "Người dùng thường",
  "pageText.member.gameCategory3DHall": "Sảnh 3D",
  "pageText.common.autoLogout": "Tự động đăng xuất",
  "pageText.common.stay": "Ở lại",
  "pageText.common.leave": "Rời đi",
  "pageText.common.autoLogoutReason": "Để tránh hành vi xấu khi bạn rời khỏi máy tính",
  "pageText.common.autoLogoutStayHint": "Để tiếp tục đăng nhập, hãy bấm \"Ở lại\"",
  "pageText.common.scrollToTop": "Cuộn lên đầu",
  "pageText.common.scrollToBottom": "Cuộn xuống cuối",
  "pageText.common.uploadTimeout": "Tải lên quá thời gian",
  "pageText.common.imageUploadFailed": "Tải ảnh lên thất bại",
  "pageText.common.uploadingImage": "Đang tải ảnh lên...",
  "pageText.common.enterContent": "Nhập nội dung...",
  "pageText.common.selectAll": "Chọn tất cả",
  "pageText.common.selectVipLevel": "Chọn cấp VIP",
  "pageText.common.uploadSuccess": "Tải lên thành công",
  "pageText.common.uploadFailed": "Tải lên thất bại",
  "pageText.common.metaDescPreview": "Meta description sẽ hiển thị ở đây…"
};
